// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m6-3";
export var downloadButton = "_m6-4";
export var fileContainer = "_m6-9 _m6-7";
export var fileContainerBase = "_m6-7";
export var fileContainerFixedHeight = "_m6-8 _m6-7";
export var fileInfo = "_m6-5";
export var fileInfoWidthRestricted = "_m6-6";
export var fileType = "_m6-1";
export var fileTypeName = "_m6-2";
export var image = "_m6-0";
export var link = "_m6-b";
export var overflowEllipsis = "_m6-a";